import Image from 'next/image';
import React, { useEffect, useState } from 'react';

import CloseIcon from '@/assets/icons/CloseIcon.svg';
import WhatsappIcon from '@/assets/icons/whatsapp-icon.svg';

const FloatingWhatsappIcon = () => {
  const [notificationVisible, setNotificationVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setNotificationVisible(true);
    }, 2000);
  }, []);

  return (
    <div className="wa-container">
      {notificationVisible && (
        <div className="notification">
          <span
            className="close-icon"
            onClick={() => setNotificationVisible(false)}
          >
            <Image style={{ color: undefined }} src={CloseIcon} alt="" />
          </span>
          <span className="notification-text">
            Hi there! How can we help you? Tap here to chat with us.
          </span>
        </div>
      )}
      <a
        href="https://wa.me/919633740733?text=Hi"
        className="wa-icon-container"
        target="_blank"
      >
        <Image
          style={{ color: undefined }}
          src={WhatsappIcon}
          className="wa-img"
          alt="whatsapp-icon"
        />
      </a>
    </div>
  );
};

export default FloatingWhatsappIcon;
